import React from "react";
import "./ContactSection.css";
import { FaWhatsapp } from "react-icons/fa";

const ContactSection = () => {
  return (
    <section className="contact-section">
      <div className="contact-card">
        <div className="contact-icon">
          <FaWhatsapp />
        </div>

        <h3 className="contact-title">Contact Us</h3>

        <p className="contact-text">
          Have any questions or suggestions? Feel free to reach us directly on
          WhatsApp.
        </p>

        <a
          href="https://wa.me/8801341707373"
          target="_blank"
          rel="noopener noreferrer"
          className="whatsapp-btn"
        >
          Chat on WhatsApp
        </a>
      </div>
    </section>
  );
};

export default ContactSection;
